export var FormUrlType = /*#__PURE__*/ function(FormUrlType) {
    FormUrlType["CollectResponses"] = "CollectResponses";
    FormUrlType["EditForm"] = "EditForm";
    FormUrlType["ViewResponses"] = "ViewResponses";
    return FormUrlType;
}({});
